// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__Z2wEt","withBackground":"styles_withBackground__UbglS","icon":"styles_icon__nf7x_"};